import { useOrg } from '@/contexts/OrgContext';

/**
 * The org id public tenant pages should query with — `undefined` while the
 * tenant is still being resolved from the subdomain.
 *
 * OrgProvider starts on the fallback (Polished Version) org and swaps to the
 * real tenant once `get_org_by_slug` answers. Querying with that interim id
 * would briefly paint another business's hero, services and reviews, so tenant
 * sections wait (and show skeletons) until `loading` clears.
 */
export function useTenantOrgId(): string | undefined {
  const { orgId, loading } = useOrg();
  return loading ? undefined : orgId;
}

/**
 * Show a skeleton only while a query waits for its *first* answer. If that
 * attempt fails, React Query keeps the query pending through its retries;
 * we fall back to the section's default content then instead of holding a
 * shimmer for several seconds.
 */
export function isAwaitingFirstResult(query: { isPending: boolean; failureCount: number }) {
  return query.isPending && query.failureCount === 0;
}
